import React from 'react';
import { motion } from 'framer-motion';
export function WhatYouGet() {
  const items = ['1 ebook digital listo para descargar.', 'Acceso inmediato después de la compra.', 'Contenido enfocado en crecimiento personal, espiritualidad y expansión de conciencia.', 'Una lectura diseñada para ayudarte a reflexionar, cuestionar creencias y despertar una nueva visión de ti.', 'Formato digital práctico para leer desde tu celular, tablet o computadora.'];
  return <section className="py-12 md:py-16 bg-matrix-black relative px-4" data-id="element-197">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10 md:mb-14" data-id="element-199">
          
          <h2 className="font-cinzel text-3xl md:text-4xl lg:text-5xl text-matrix-cream mb-6 drop-shadow-[0_0_10px_rgba(245,230,200,0.1)]" data-id="element-200">
            ¿QUÉ RECIBES CON TU COMPRA?
          </h2>
          <p className="text-base md:text-lg text-matrix-white/80 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-201">
            Al adquirir este ebook, recibirás acceso inmediato a una experiencia
            de lectura creada para acompañarte en tu proceso de reflexión,
            conciencia y transformación interior.
          </p>
        </motion.div>

        <div className="space-y-4 md:space-y-6" data-id="element-202">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-matrix-dark/40 p-5 md:p-6 rounded-lg border border-matrix-green/10 hover:border-matrix-green/30 transition-colors" data-id="element-203">
            
              <span className="text-matrix-green font-bold text-xl leading-none mt-1" data-id="element-204">
                —
              </span>
              <p className="text-matrix-white text-base md:text-lg font-light leading-relaxed" data-id="element-205">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}